// import React, { useState } from 'react';

// import CheckboxDetails from './CheckboxDetails';

// const Checkbox: React.FC = () => {
//   const [isChecked, setIsChecked] = useState(false);

//   return (
//     <div>
//       <CheckboxDetails
//         checked={isChecked}
//         onChange={checked => setIsChecked(checked)}
//         label='I agree to the terms'
//         size='medium'
//         borderColor='#4A90E2'
//         backgroundColor='#E5F1FB'
//         checkColor='#007bff'
//       />
//     </div>
//   );
// };

// export default Checkbox;
import React from 'react';

const Checkbox = () => {
  return <div>Checkbox</div>;
};

export default Checkbox;
